var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaypal = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 24,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 24,
  fill: "url(#paypal_svg__a)",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#28356A",
  fillRule: "evenodd",
  d: "m13.595 18.33.228-1.494-.507-.012h-2.422l1.683-11.031a.15.15 0 0 1 .047-.087.14.14 0 0 1 .09-.034h4.084c1.356 0 2.291.291 2.78.867a2 2 0 0 1 .445.863c.074.326.075.715.003 1.19l-.005.034v.304l.229.135q.288.157.464.365c.196.23.322.524.376.872.055.358.037.784-.054 1.266-.104.554-.273 1.037-.501 1.432q-.316.547-.795.9a3.2 3.2 0 0 1-1.07.5c-.395.105-.844.159-1.338.159h-.317a.95.95 0 0 0-.622.236 1 1 0 0 0-.324.598l-.024.134-.402 2.635-.018.097c-.005.03-.013.046-.025.056a.07.07 0 0 1-.042.016z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ADD0E6",
  fillRule: "evenodd",
  d: "M20.467 8.66q-.018.12-.041.248c-.539 2.858-2.382 3.845-4.735 3.845h-1.198a.59.59 0 0 0-.575.51l-.787 5.16a.314.314 0 0 0 .302.367h2.125a.52.52 0 0 0 .505-.445l.021-.112.4-2.625.026-.144a.52.52 0 0 1 .505-.446h.318c2.059 0 3.67-.864 4.142-3.364.197-1.045.095-1.917-.426-2.53a2 2 0 0 0-.582-.464",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6EFF6",
  fillRule: "evenodd",
  d: "M19.904 8.43a4 4 0 0 0-.524-.12 6.5 6.5 0 0 0-1.057-.08h-3.2a.5.5 0 0 0-.221.052.53.53 0 0 0-.284.395l-.681 4.458-.02.13a.59.59 0 0 1 .575-.51h1.199c2.353 0 4.196-.988 4.734-3.845q.024-.127.042-.248a2.8 2.8 0 0 0-.563-.232",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M14.618 8.676a.52.52 0 0 1 .284-.395.5.5 0 0 1 .22-.051h3.202q.57-.001 1.056.08a5 5 0 0 1 .524.12l.12.038q.24.082.444.193c.16-1.056-.002-1.775-.554-2.426-.61-.717-1.709-1.024-3.116-1.024h-4.084a.59.59 0 0 0-.577.51l-1.7 11.144c-.034.22.13.42.346.42h2.52z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paypal_svg__a",
  x1: 0,
  x2: 32,
  y1: 0,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#012C70"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#019ADD"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaypal);
export default ForwardRef;